import { RiskDetailsDatagrid } from '@Components/RiskDetails';
import { RiskDetailsMap } from '@Components/RiskDetails/Map/RiskDetailsMap.component';
import { ReactMapProps } from '@innovyze/inno-map';
import React, { useState } from 'react';
import styled from 'styled-components';

interface Props {
	configId: string;
	refreshRiskScore: () => void;
}

const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: 10px;
	height: calc(100vh - 230px);
	min-height: 900px;
`;

export const RiskDetailsWithMap = ({ configId, refreshRiskScore }: Props) => {
	const [focusedAssets, setFocusedAssets] = useState<
		ReactMapProps['focusedAssets']
	>([]);
	return (
		<Wrapper>
			<RiskDetailsDatagrid
				configId={configId}
				refreshRiskScore={refreshRiskScore}
				setFocusedAssets={setFocusedAssets}
				autoHeight={false}
			/>
			<RiskDetailsMap configId={configId} focusedAssets={focusedAssets} />
		</Wrapper>
	);
};
